import { ConfigurationRepositoryWorkspacesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryWorkspacesService'
import {
  assertNotEmpty,
  type ConfigurableServer,
  notEmpty,
  type Optional,
} from '@festina-life/core'
import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'

import * as configurationKeys from '../keys/configuration'

export const useFetchWorkspaceOperations = ({
  server,
  workspaceName,
  enabled,
}: {
  server: Optional<ConfigurableServer>
  enabled: boolean
  workspaceName: Optional<string>
}) => {
  const fetcher = useCallback(async () => {
    assertNotEmpty(workspaceName)
    assertNotEmpty(server)

    const result =
      await ConfigurationRepositoryWorkspacesService.workspaceServiceGetGetWorkspaceOperations(
        { workspaceName, componentName: server.toLocaleLowerCase() },
      )

    return result?.workspaceOperations?.filter(notEmpty) ?? []
  }, [server, workspaceName])

  return useQuery({
    enabled: enabled && !!workspaceName && !!server,
    queryKey:
      server && workspaceName
        ? configurationKeys.fetchWorkspaceOperationsKey({
            workspaceName,
            server,
          })
        : [],
    queryFn: fetcher,
  })
}
